import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'

export default function WelcomeStaffCard({user, showLicensedTeam, showLocationTeam}) {
  let fullName = `${user.firstName} ${user.lastName}`

  if (user.credentials) {
    fullName = `${fullName}, ${user.credentials}`
  }
  
  return (
    <Card className='border-0 axs-shadow axs-rounded h-100'>
      <Card.Body className='py-5 px-4 mx-3 d-flex flex-column justify-content-around'>
        <Row>
          <Col className='text-center'>
            <h6>{fullName} was successfully added to your organization!</h6>
            <span className='text-muted font-weight-light'>An account setup email has been sent.</span>
          </Col>
        </Row>
        <br />
        <Row>
          <Col className='text-center mt-4 mb-5'>
            <i className="fas fa-check-circle fa-lg" style={{color: '#1ab2e9', fontSize: '5em'}}></i>
          </Col>
        </Row>
        <br />
        <Row className='font-weight-light'>
          <Col className='pr-5'>
            <Row>
              <Col>
                Licensed Team
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                By adding to a licensed user's team, any notifications to the licensed user will be delivered to Jane Doe and the other team members.
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Button onClick={showLicensedTeam} block variant='success'>Assign to a Licensed Team</Button>
              </Col>
            </Row>
          </Col>

          {/* <Col>
            <Row>
              <Col>
                Location Team
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                By adding to a licensed user's team, any notifications to the licensed user will be delivered to Jane Doe and the other team members.
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Button onClick={showLocationTeam} block variant='success'>Assign to a Location Team</Button>
              </Col>
            </Row>
          </Col> */}

        </Row>
      </Card.Body>
    </Card>
  )
}
